import { authCRUD } from "../../../actions/auth"
import { selector } from "../../../api"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useEffect, useState } from "react"
import Select from "react-select";
import { toast } from "react-toastify"
import { boundaryCRUD } from "../../../actions/boundary"
import { dictionaryCRUD } from "../../../actions/dictionary"

const leaderSchema = Yup.object().shape({
  password: Yup.string().min(8, 'Minimum 8 characters').required('Password is required'),
  password_confirm : Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match').required('Password is required'),
  username: Yup.string().required('Username is required'),
  full_name: Yup.string().required('Full name is required'),
  phone_number: Yup.string().required('Phone number is required'),
  dob: Yup.string().required('Date of birth is required'),
  emaila_ddress: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols'),
  dictionary_gender: Yup.string(),
  dictionary_leader_type: Yup.string().nullable(),
  boundary_id: Yup.string(),
  groups: Yup.array()
});

const initialValues = {
  username: '',
  password: '',
  password_confirm: '',
  full_name: '',
  phone_number: '',
  dob: '',
  emaila_ddress: '',
  is_active: true,
  dictionary_gender: '',
  dictionary_leader_type: '',
  boundary_id: '',
}
export const AddLeader = (props) => {

  const {setIndex, index} = props

  const [loading, setLoading] = useState(false)
  const [boundary, setBoundary] = useState([])
  const [gender, setGender] = useState([])
  const [leaderType, setLeaderType] = useState([])
  const [leader, setLeader] = useState(null)
  const [checked, setChecked] = useState(false)
  const [group, setGroup] = useState([])
  const user = selector.User()

  // Cascading dropdown states
  const [regions, setRegions] = useState([])
  const [districts, setDistricts] = useState([])
  const [selectedRegion, setSelectedRegion] = useState(null)
  const [selectedDistrict, setSelectedDistrict] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadDictionaryData(10, 0, '', 1).then((resp) => {
        setGender(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(10, 0, '', 10).then((resp) => {
        setLeaderType(resp.data.results)
      }).finally(() => {})
    }, 500)
  }, [])

  // Load regions when leader type is selected
  useEffect(() => {
    // Reset cascading selections when leader type changes
    setSelectedRegion(null)
    setSelectedDistrict(null)
    setDistricts([])
    setBoundary([])

    if(leader === 32) {
      // Region leader - load all regions directly
      boundaryCRUD.loadBoundary(1000, 0, 'Region', '').then((resp) => {
        setBoundary(resp.data.results)
        setGroup([5])
      }).catch((error) => {
        console.log(error);
      })
    } else if(leader === 31 || leader === 30) {
      // District or Locality leader - load regions first for cascading
      boundaryCRUD.loadBoundary(1000, 0, 'Region', '').then((resp) => {
        setRegions(resp.data.results)
        setGroup(leader === 31 ? [4] : [2])
      }).catch((error) => {
        console.log(error);
      })
    }
  }, [leader])

  // Load districts when region is selected
  useEffect(() => {
    if(selectedRegion) {
      boundaryCRUD.loadBoundaryByParent(selectedRegion).then((resp) => {
        setDistricts(resp.data)
        if(leader === 31) {
          // For district leader, districts are the final selection
          setBoundary(resp.data)
        }
      }).catch((error) => {
        console.log(error);
      })
    }
    setSelectedDistrict(null)
    if(leader === 30) {
      setBoundary([])
    }
  }, [selectedRegion])

  // Load localities when district is selected
  useEffect(() => {
    if(selectedDistrict && leader === 30) {
      boundaryCRUD.loadBoundaryByParent(selectedDistrict).then((resp) => {
        setBoundary(resp.data)
      }).catch((error) => {
        console.log(error);
      })
    }
  }, [selectedDistrict])

  const formik = useFormik({
    initialValues,
    validationSchema: leaderSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { password, username, full_name, phone_number, dob, emaila_ddress, is_active, dictionary_gender, dictionary_leader_type, boundary_id } = values
      const recorded_by = user.id
      const groups = group
      const data = { password, username, full_name, dob, phone_number, is_active, dictionary_gender, dictionary_leader_type, boundary_id, emaila_ddress, groups, recorded_by }

      setLoading(true)
      setTimeout(() => {
        authCRUD.addUser(data).then((resp) => {
          const leader = { ...data, user_account: resp.data.id };
          boundaryCRUD.addBoundaryLeader(leader).then(() => {
            toast.success('New leader has been created.', { autoClose: 7000 })
            resetForm()
            setSelectedRegion(null)
            setSelectedDistrict(null)
            setIndex(index+1)
            setLoading(false)
            setSubmitting(false)
          }).catch((error) => {
            toast.error(error.message, { autoClose: 7000 })
            setLoading(false)
            setSubmitting(false)
          })
        }).catch((error) => {
          toast.error(error.message, { autoClose: 7000 })
          setLoading(false)
          setSubmitting(false)
        })
      }, 2000)
    }
  })

  // Check if we need cascading dropdowns
  const showCascadingDropdowns = leader === 31 || leader === 30

  return (
    <>
      <div class="modal fade addModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">New Leader</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr/>
            <form onSubmit={formik.handleSubmit}>
              <div class="modal-body">
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div class="mb-3">
                      <label for="full_name" class="form-label">Full Name <span className="text-danger">*</span></label>
                      <input type="text" id="full_name" {...formik.getFieldProps('full_name')} class="form-control" placeholder="Full Name" />
                      {formik.touched.full_name && formik.errors.full_name && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.full_name}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div class="mb-3">
                      <label for="dictionary_gender" class="form-label">Gender <span className="text-danger">*</span></label>
                      <Select
                        options={
                          gender?.map((dt) => (
                            {value : dt.id, label : dt.dictionary_item_name_en}
                          ))
                        }
                        placeholder="Select gender"
                        onChange={(e) => formik.setFieldValue('dictionary_gender', e.value)}
                        isSearchable={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div class="mb-3">
                      <label for="dob" class="form-label">Date of Birth <span className="text-danger">*</span></label>
                      <input type="date" id="dob" {...formik.getFieldProps('dob')} class="form-control" placeholder="Date of Birth" />
                      {formik.touched.dob && formik.errors.dob && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.dob}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div class="mb-3">
                      <label for="phone_number" class="form-label">Phone Number <span className="text-danger">*</span></label>
                      <input type="text" id="phone_number" {...formik.getFieldProps('phone_number')} class="form-control" placeholder="Phone Number" />
                      {formik.touched.phone_number && formik.errors.phone_number && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.phone_number}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div class="mb-3">
                      <label for="email" class="form-label">Email Address</label>
                      <input type="email" id="email" {...formik.getFieldProps('emaila_ddress')} class="form-control" placeholder="Email Address" />
                      {formik.touched.emaila_ddress && formik.errors.emaila_ddress && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.emaila_ddress}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div class="mb-3">
                      <label for="dictionary_leader_type" class="form-label">Leader Type <span className="text-danger">*</span></label>
                      <Select
                        options={
                          leaderType?.map((dt) => (
                            {value : dt.id, label : dt.dictionary_item_name_en}
                          ))
                        }
                        placeholder="Select leader type"
                        onChange={(e) => {formik.setFieldValue('dictionary_leader_type', e.value); setLeader(e.value)}}
                        isSearchable={true}
                      />
                    </div>
                  </div>
                </div>

                {/* Cascading dropdowns for District and Locality leaders */}
                {showCascadingDropdowns && (
                  <div className="row">
                    <div className={leader === 30 ? "col-md-4 col-sm-12" : "col-md-6 col-sm-12"}>
                      <div class="mb-3">
                        <label class="form-label">Region <span className="text-danger">*</span></label>
                        <Select
                          options={
                            regions?.map((dt) => (
                              {value : dt.id, label : dt.boundary_name}
                            ))
                          }
                          value={selectedRegion ? regions.filter(r => r.id === selectedRegion).map(r => ({value: r.id, label: r.boundary_name}))[0] : null}
                          placeholder="Select region"
                          onChange={(e) => setSelectedRegion(e.value)}
                          isSearchable={true}
                        />
                      </div>
                    </div>
                    {leader === 30 && (
                      <div className="col-md-4 col-sm-12">
                        <div class="mb-3">
                          <label class="form-label">District <span className="text-danger">*</span></label>
                          <Select
                            options={
                              districts?.map((dt) => (
                                {value : dt.id, label : dt.boundary_name}
                              ))
                            }
                            value={selectedDistrict ? districts.filter(d => d.id === selectedDistrict).map(d => ({value: d.id, label: d.boundary_name}))[0] : null}
                            placeholder="Select district"
                            onChange={(e) => setSelectedDistrict(e.value)}
                            isSearchable={true}
                            isDisabled={!selectedRegion}
                          />
                        </div>
                      </div>
                    )}
                    <div className={leader === 30 ? "col-md-4 col-sm-12" : "col-md-6 col-sm-12"}>
                      <div class="mb-3">
                        <label for="boundary_id" class="form-label">{leader === 31 ? 'District' : 'Shehia'} <span className="text-danger">*</span></label>
                        <Select
                          options={
                            boundary?.map((dt) => (
                              {value : dt.id, label : dt.boundary_name}
                            ))
                          }
                          placeholder={`Select ${leader === 31 ? 'district' : 'shehia'}`}
                          onChange={(e) => formik.setFieldValue('boundary_id', e.value)}
                          isSearchable={true}
                          isDisabled={leader === 31 ? !selectedRegion : !selectedDistrict}
                        />
                        {formik.touched.boundary_id && formik.errors.boundary_id && (
                          <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                            <span role='alert' className='text-danger'>{formik.errors.boundary_id}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Direct boundary selection for Region leaders */}
                {leader === 32 && (
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div class="mb-3">
                        <label for="boundary_id" class="form-label">Region <span className="text-danger">*</span></label>
                        <Select
                          options={
                            boundary?.map((dt) => (
                              {value : dt.id, label : dt.boundary_name}
                            ))
                          }
                          placeholder="Select region"
                          onChange={(e) => formik.setFieldValue('boundary_id', e.value)}
                          isSearchable={true}
                        />
                        {formik.touched.boundary_id && formik.errors.boundary_id && (
                          <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                            <span role='alert' className='text-danger'>{formik.errors.boundary_id}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div class="mb-3">
                      <label for="username" class="form-label">Username <span className="text-danger">*</span></label>
                      <input type="text" id="username" {...formik.getFieldProps('username')} class="form-control" placeholder="Username" />
                      {formik.touched.username && formik.errors.username && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.username}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <label for="password" class="form-label">Password <span className="text-danger">*</span></label>
                    <div class="mb-3 position-relative auth-pass-inputgroup ">
                      <input type={checked ? "text" : "password"}  {...formik.getFieldProps('password')} class="form-control pe-5 password-input" placeholder="Password" />
                      <button onClick={() => setChecked(!checked)} className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon">
                        <i className={checked ? "bi bi-eye-slash-fill" : "bi bi-eye-fill"} style={{fontSize: '15px'}}></i>
                      </button>
                      {formik.touched.password && formik.errors.password && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.password}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <label for="password" class="form-label">Confirm Password <span className="text-danger">*</span></label>
                    <div class="mb-3 position-relative auth-pass-inputgroup">
                      <input type={checked ? "text" : "password"}  {...formik.getFieldProps('password_confirm')} class="form-control pe-5 password-input" placeholder="Password Confirmation" />
                      <button onClick={() => setChecked(!checked)} className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon">
                        <i className={checked ? "bi bi-eye-slash-fill" : "bi bi-eye-fill"} style={{fontSize: '15px'}}></i>
                      </button>
                      {formik.touched.password_confirm && formik.errors.password_confirm && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.password_confirm}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <hr/>
              <div className="modal-footer">
                <a href="javascript:void(0);" className="btn btn-soft-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
                <button type='submit' className="btn btn-soft-success" disabled={formik.isSubmitting || !formik.isValid}>
                  {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>save </span>}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )

}
